import { type Module } from "vuex";
import type { DefaultApi } from "@/api";
import { ShortMessage } from "@/models/short_message";
import { ShortMessages } from "@/models/short_messages";
import type { State as RootState } from "@/stores";
export interface State {}

// We will not cache short messages
export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async getCandidateTimeline(
      {},
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getCandidateTimeline(candidateId, positionId);
      return new ShortMessages(
        response.data.map((shortMessage) => new ShortMessage(shortMessage)),
      );
    },
    async postShortMessage(
      { commit },
      {
        positionId,
        candidateId,
        messageBody,
        resumeAutomation = false,
      }: {
        positionId: number;
        candidateId: number;
        messageBody: string;
        resumeAutomation?: boolean;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postShortMessage(
        positionId,
        candidateId,
        messageBody,
        resumeAutomation,
      );
      commit("statistics/invalidateStatistics", null, { root: true });
      return new ShortMessage(response.data);
    },
    async getTranslatedCandidateTimeline(
      {},
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getTranslatedCandidateTimeline(
        candidateId,
        positionId,
      );
      return new ShortMessages(
        response.data.map((shortMessage) => new ShortMessage(shortMessage)),
      );
    },
  },
};
